import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { toast } from "sonner";

const STAGES = [
  { key: "input",   label: "Input",   sub: "Lead → Contract" },
  { key: "process", label: "Process", sub: "Pre → Prod → Post" },
  { key: "output",  label: "Output",  sub: "Review · Revise" },
  { key: "closure", label: "Closure", sub: "Pay · Archive" },
];

export default function Pipeline() {
  const [projects, setProjects] = useState([]);

  const load = async () => setProjects(await api.listProjects());
  useEffect(() => { load(); }, []);

  const onDrop = async (e, stage) => {
    e.preventDefault();
    const id = e.dataTransfer.getData("text/plain");
    if (!id) return;
    try {
      await api.updateProject(id, { stage });
      await load();
      toast.success(`Moved to ${stage.toUpperCase()}`);
    } catch { toast.error("Could not move card"); }
  };

  return (
    <div className="space-y-6" data-testid="pipeline">
      <div>
        <div className="mono text-white/40">FACTORY · PIPELINE</div>
        <h1 className="text-4xl font-extrabold mt-2">Kanban</h1>
        <p className="text-white/60 mt-2 max-w-2xl">Drag cards across the four factory stages. Input → Process → Output → Closure.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border border-white/10">
        {STAGES.map((s, i) => (
          <div key={s.key}
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => onDrop(e, s.key)}
            className={`bg-[#0C0C0C] min-h-[60vh] ${i > 0 ? 'lg:border-l border-white/10' : ''} ${i > 0 ? 'md:border-t lg:border-t-0' : ''}`}
            data-testid={`column-${s.key}`}
          >
            <div className="px-4 py-3 border-b border-white/10 flex items-center justify-between sticky top-14 bg-[#0C0C0C] z-10">
              <div>
                <div className="mono text-kinetic">{s.label}</div>
                <div className="mono text-white/30 mt-0.5">{s.sub}</div>
              </div>
              <div className="mono text-white/40">{projects.filter(p => p.stage === s.key).length}</div>
            </div>
            <div className="p-3 space-y-2">
              {projects.filter(p => p.stage === s.key).map(p => (
                <div
                  key={p.id}
                  draggable
                  onDragStart={(e) => e.dataTransfer.setData("text/plain", p.id)}
                  data-testid={`kanban-card-${p.id}`}
                  className="bg-[#161616] border border-white/10 hover:border-kinetic transition p-3 cursor-grab active:cursor-grabbing"
                >
                  <Link to={`/app/factory/projects/${p.id}`} className="block">
                    <div className="font-sans font-bold">{p.title}</div>
                    <div className="mono text-white/40 mt-1">{p.client_name}</div>
                    <div className="flex items-center justify-between mt-3">
                      <span className="mono text-white/50">₹{(p.budget||0).toLocaleString('en-IN')}</span>
                      <div className="flex gap-0.5">
                        {[p.milestone_advance, p.milestone_mid, p.milestone_final].map((on, i) => (
                          <span key={i} className={`w-2 h-2 ${on ? 'bg-neon' : 'bg-white/15'}`} />
                        ))}
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
              {projects.filter(p => p.stage === s.key).length === 0 && (
                <div className="mono text-white/30 px-2 py-6 text-center">EMPTY</div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
